module.exports = __webpack_public_path__ + "static/media/36.e90c73e2.png";